import React, { useState } from "react";
import { IconButton, Input, InputGroup, InputRightElement } from "@chakra-ui/react";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";

// Drop-in replacement for a Chakra <Input type="password" ... /> that adds a
// show/hide toggle, built from Chakra's own InputGroup/InputRightElement
// primitives. All other props (size, placeholder, value, onChange, etc.)
// pass through to Input unchanged.
const PasswordInput = (props) => {
  const [show, setShow] = useState(false);

  return (
    <InputGroup size={props.size}>
      <Input {...props} type={show ? "text" : "password"} />
      <InputRightElement>
        <IconButton
          aria-label={show ? "Hide password" : "Show password"}
          icon={show ? <IoEyeOffOutline /> : <IoEyeOutline />}
          size="xs"
          variant="ghost"
          tabIndex={-1}
          onClick={() => setShow((prev) => !prev)}
        />
      </InputRightElement>
    </InputGroup>
  );
};

export default PasswordInput;
